export const CONFIG = {
  ...window.MyConfig,
  isDevelopment: window.MyConfig.env === 'development',
  isProduction: window.MyConfig.env === 'production',
};
